import { SIGN_OUT_USER } from "../auth/authConstants";
import { COUNTRY_CY, getCountryGeolocation } from "../data/countries";
import { CURRENCY_EUR } from "../data/currencies";

export const UPDATE_MAP_LOCATION = "UPDATE_MAP_LOCATION";
export const RESET_MAP_LOCATION = "RESET_MAP_LOCATION";
export const SELECT_VIEW_LIST_MODE_JOB = "SELECT_VIEW_LIST_MODE_JOB";
export const SET_CLUSTERED_MAP = "SET_CLUSTERED_MAP";
export const UPDATE_COVERAGE_AREA_LEVEL_ONE = "UPDATE_COVERAGE_AREA_LEVEL_ONE";
export const GOOGLE_MAPS_API_LOADED = "GOOGLE_MAPS_API_LOADED";

export const MAP_INITIAL_STATE = {
  clustered: true,
  loaded: false,
  location: {
    zoom: 10,
    address: null,
    center: getCountryGeolocation(COUNTRY_CY).center,
  },
  isGoogleMapsApiLoaded: false,
  viewListModeJob: null,
  coverage: {
    countryCode: COUNTRY_CY,
    currencyCode: CURRENCY_EUR,
    areaLevelOne: null,
  },
};

export default function mapReducer(
  state = MAP_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case UPDATE_MAP_LOCATION:
      return {
        ...state,
        loaded: true,
        location: {
          zoom: payload.zoom,
          address: payload.address,
          center: payload.center,
        },
        viewListModeJob: null,
      };
    case RESET_MAP_LOCATION:
      return {
        ...MAP_INITIAL_STATE,
      };
    case SELECT_VIEW_LIST_MODE_JOB:
      return {
        ...state,
        viewListModeJob: payload,
      };
    case SET_CLUSTERED_MAP:
      return {
        ...state,
        clustered: payload,
      };
    case UPDATE_COVERAGE_AREA_LEVEL_ONE: {
      return {
        ...state,
        coverage: {
          ...state.coverage,
          areaLevelOne: payload,
        },
      };
    }
    case GOOGLE_MAPS_API_LOADED: {
      return {
        ...state,
        isGoogleMapsApiLoaded: true,
      };
    }
    case SIGN_OUT_USER:
      return {
        ...MAP_INITIAL_STATE,
      };
    default:
      return state;
  }
}
